// @ts-nocheck
import {
  ArrowUpIcon,
  Box,
  Button,
  Grid,
  GridItem,
  Stack,
  Text,
} from "@smoothie-framework/ui";
import { asset, Gutter } from "./shared";

export function Footer() {
  return (
    <Box
      as="footer"
      className="footer section-dark"
      background="background"
      minH={{ base: 149.5, lg: 133.75 }}
      py={{ base: 16, md: 20 }}
    >
      <img src={asset("footer-glow.png")} alt="" aria-hidden="true" />
      <Gutter className="footer-panel">
        <Box
          background="surface1"
          border="sm"
          borderColor="borderSubtle"
          rounded="lg"
          shadow="lg"
          p={{ base: 7, md: 12 }}
        >
          <Grid
            columns={{ base: 1, md: 2, lg: "1.35fr 1fr 1fr 1fr" }}
            gap={{ base: 5, md: 12 }}
            minH={42}
          >
            <GridItem colSpan={{ base: 1, md: 2, lg: 1 }}>
              <Stack gap={4} justify="start">
                <Text as="strong" textStyle="brand-footer">
                  ZEQUELS
                </Text>
                <Text as="span" textStyle="meta" uppercase color="accent">
                  AI micro-drama studio
                </Text>
                <Text as="p" textStyle="body-sm" color="subtle">
                  Your story. Your creative vision.
                  <br />A series waiting to happen.
                </Text>
              </Stack>
            </GridItem>
            <Box display={{ base: "none", lg: "block" }} />
            <Stack gap={2} justify="start">
              <Text as="strong" textStyle="label">
                Get in touch
              </Text>
              <Text asChild textStyle="caption" color="subtle">
                <a href="mailto:joram@zequels.com">joram@zequels.com</a>
              </Text>
            </Stack>
            <Stack gap={2} justify="start">
              <Text as="strong" textStyle="label">
                Legal
              </Text>
              <Text as="span" textStyle="caption" color="disabled">
                Terms &amp; Conditions
              </Text>
              <Text as="span" textStyle="caption" color="disabled">
                Privacy Policy
              </Text>
            </Stack>
          </Grid>
          <Stack
            align={{ base: "start", lg: "center" }}
            borderTopWidth="sm"
            borderTopStyle="solid"
            borderTopColor="border"
            direction={{ base: "column", lg: "row" }}
            justify="between"
            mt={{ base: 8, md: 12 }}
            pt={7}
          >
            <Text as="span" textStyle="caption" color="subtle">
              © 2026 ZEQUELS ApS. All rights reserved.
            </Text>
            <Button
              asChild
              rightIcon={ArrowUpIcon({ size: "sm" })}
              size="sm"
              variant="ghost"
            >
              <a href="#top">Back to top</a>
            </Button>
          </Stack>
        </Box>
      </Gutter>
    </Box>
  );
}
